'use client'

import type { ReactNode } from 'react'

interface MainContentProps {
  children: ReactNode
  className?: string
}

export function MainContent({ children, className }: MainContentProps) {
  return (
    <main id="main-content" className={className}>
      {children}
    </main>
  )
}
